import React from 'react';

import AaSequenceChainPreview from 'molbio/aa-sequences/complex/AaSequenceChainPreview';
import {AaSequenceComplex} from 'molbio/aa-sequences/complex/AaSequenceComplexConstants';

export default function AaSequenceComplexPreviewBody({
  proteins,
}: {
  proteins: Array<AaSequenceComplex>;
}): JSX.Element {
  return (
    <div className="container u-spacing-top">
      {proteins.map((protein, i) => (
        <AaSequenceChainPreview key={i} name={protein.name} aminoAcids={protein.aminoAcids} />
      ))}
    </div>
  );
}
